import type { FC } from 'react';
import { useEffect } from 'react';
import { toast } from 'sonner';

import { getDevSettingsFromUrl } from '../../../utils/devSettings/getDevSettingsFromUrl';

export const DevSettingsImportNotification: FC = () => {
  useEffect(() => {
    const urlSettings = getDevSettingsFromUrl({
      search: window.location.search,
    });

    if (!urlSettings) {
      return;
    }

    const enabledExtensions: string[] = [];
    const disabledExtensions: string[] = [];

    if (urlSettings.extensions) {
      Object.entries(urlSettings.extensions).forEach(([name, enabled]) => {
        if (enabled) {
          enabledExtensions.push(name);
        } else {
          disabledExtensions.push(name);
        }
      });
    }

    // Show toast with formatted description
    toast.success('Settings imported from URL', {
      description: (
        <div className="space-y-2 text-sm">
          {urlSettings.environmentId && (
            <div>
              <span className="font-semibold">Environment:</span>{' '}
              {urlSettings.environmentId}
            </div>
          )}
          {urlSettings.apiBaseUrlOrigin && (
            <div>
              <span className="font-semibold">API:</span>{' '}
              {urlSettings.apiBaseUrlOrigin + urlSettings.apiBaseUrlPath}
            </div>
          )}
          {enabledExtensions.length > 0 && (
            <div>
              <span className="font-semibold">Enabled:</span>{' '}
              {enabledExtensions.join(', ')}
            </div>
          )}
          {disabledExtensions.length > 0 && (
            <div>
              <span className="font-semibold">Disabled:</span>{' '}
              {disabledExtensions.join(', ')}
            </div>
          )}
        </div>
      ),
      duration: 5000,
    });

    // Remove only known dev setting params from URL
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    params.delete('environmentId');
    params.delete('apiBaseUrlOrigin');
    params.delete('apiBaseUrlPath');
    params.delete('extensions');

    url.search = params.toString();
    window.history.replaceState({}, '', url.toString());
  }, []);

  return null;
};
